import { encryptField } from '@app/utils/utils';
import { handleHttpRequest } from './common.api';
import {
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
  ForgotPasswordRequest,
  SecurityCodePayload,
  RequestOTPRequest,
  RequestOTPResponse,
} from '@app/interfaces/auth';

const baseSlug = '/auth';

export const login = (loginPayload: LoginRequest): Promise<LoginResponse> => {
  return handleHttpRequest<LoginResponse, LoginRequest>('post', `${baseSlug}/login`, {
    ...loginPayload,
    password: encryptField(loginPayload.password as string),
  });
};

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<undefined> => {
  return handleHttpRequest<undefined, Partial<ResetPasswordRequest>>(
    'post',
    `${baseSlug}/resetPassword?token=${resetPasswordPayload.token}`,
    {
      password: encryptField(resetPasswordPayload.password),
    },
  );
};

export const forgotPassword = (forgotPasswordPayload: ForgotPasswordRequest): Promise<undefined> => {
  return handleHttpRequest<undefined, ForgotPasswordRequest>(
    'post',
    `${baseSlug}/forgotPassword`,
    forgotPasswordPayload,
  );
};

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<LoginResponse> => {
  return handleHttpRequest<LoginResponse, SecurityCodePayload>('post', `${baseSlug}/verifyOtp`, {
    ...securityCodePayload,
    otp: encryptField(securityCodePayload.otp),
  });
};

export const requestOTP = (requestOTPPayload: RequestOTPRequest): Promise<RequestOTPResponse> => {
  return handleHttpRequest<RequestOTPResponse, RequestOTPRequest>('post', `${baseSlug}/requestOtp`, requestOTPPayload);
};
